import React from "react";
import styled from "styled-components";

interface ActionButtonProps {
	children?: React.ReactNode;
	props?: any;
	onClick?: any;
	onSubmit?: any;
	disabled?: boolean;
	form?: string;
}

const ActionButton: React.FC<ActionButtonProps> = ({
	onClick,
	children,
	onSubmit,
	disabled,
	form,
}) => {
	return (
		<ActionButtonStyles disabled={disabled} onSubmit={onSubmit} onClick={onClick} form={form}>
			<img src="/svg/add-circle.svg" alt="add-icon" />
			{children}
		</ActionButtonStyles>
	);
};

export default ActionButton;

const ActionButtonStyles = styled.button`
	display: flex;
	align-items: center;
	width: fit-content;
	padding: 0.4rem;
	border-radius: 5px;
	border: none;
	font-size: ${(props) => props.theme.fontSizes.FONT_SIZE_M};
	color: ${(props) => props.theme.colors.COLOR_ACTION_BLUE};
	border: 1px solid ${(props) => props.theme.colors.COLOR_ACTION_BLUE};
	background: white;

	img {
		margin-right: 0.4rem;
	}

	cursor: pointer;
`;
